/* template */
<template minapp="mpx" xlang="wxml"><es-layout custom-class :leftArrow="(true)" :layout="(['header','footer'])" custom-title="custom-title" :navbarClickLeft="(goBack)" :navbarTitle="(navbarTitle)" :navbarStyle="(navbarStyle)"><div slot="footer" :style='[("padding-bottom: "+(footerPaddingBottom))] | transRpxStyle' class="footer"><es-button size="large" custom-class="left-button" @click="goHome" :style='["flex:1;margin-right:4px"] | transRpxStyle'>返回首页</es-button><es-button size="large" custom-class="right-button" @click="goOrderDetail(2)" :style='["flex:1;margin-left:4px"] | transRpxStyle'>订单详情</es-button></div><div class="card-main"><div class="top"><es-icon color="#1473FF" size="64" name="check-circle-filled"/><div class="order-status">{{ status }}</div><div class="order-desc">{{ desc }}</div></div><mpx-view @tap="goOrderDetail(3)"><order-card v-for="(item, index) in (ticketsInfo)" :ticket="(item)" class="order-card"/></mpx-view><card-frame :cardConf="(couponInformBar)" class="card-frame" v-if="(isShowCardFrame)"/><warm-tips title="温馨提示" :content="(content)" from="success"/></div></es-layout></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0901b108"}'>
  @import '~@/mixins/stylus/color.styl'

  .custom-title
    font-size 18px
    font-family PingFangSC
  .card-main
    display flex
    flex-direction column
    background white
    padding 12px 12px 60px
    height 100%
    .card-frame
      border-radius 8px
      background #FFF6F1
      border 1.5px solid #fff
      margin-top 10px
    .top
      margin-top 28px
      margin-bottom 68px
      display flex
      flex-direction column
      background white
      align-items center
      .order-status
        text-align center
        margin-top 16px
        font-size 18px
        font-weight 500
        font-family PingFangSC
        color black
      .order-desc
        margin-top 7px
        font-size 13px
        color $train-color-666
  .footer
    background white
    height 88px
    padding 0px 12px
    position fixed
    left 0
    right 0
    bottom 0
    display flex
    justify-content space-around
    align-items center
    box-shadow 0 -4px 10px RGBA(0, 0, 0, 0.04)
    font-size 12px
    color $train-color-333
    .right-button
      font-size 16px
      font-weight 600
      height 48px
      text-align center
      color white
      border-width 0px
      border-radius 8px
      background-color $train-color-theme-blue
    .left-button
      font-size 16px
      font-weight 600
      height 48px
      color $train-color-theme-blue
      box-sizing border-box
      text-align center
      font-family PingFangSC
      border 1px solid $train-color-theme-blue
      border-radius 8px
  .order-card
    &:not(:first-child)
      margin-top 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0901b108"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./success.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./success.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m0901b108"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'card-frame':getComponent(require("../components/card-frame/index.mpx?isComponent&outputPath=components%2Findexf4806b60%2Findex")),'warm-tips':getComponent(require("../components/warm-tips/index.mpx?isComponent&outputPath=components%2Findexfd0d1b18%2Findex")),'order-card':getComponent(require("../components/order-card/index.mpx?isComponent&outputPath=components%2Findex8b3e9d62%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
